import axios from "axios";


async function findClienteSat(nit) {
    nit = nit.toUpperCase();
  
        const {data} = await axios.post('https://asecontables.microsystems.com.gt/api/getnit/index.php?op=search', { 'nit': nit })
        if(data.REQUEST_DATA[0].Respuesta==0 || data.RESPONSE[0].NIT=='CF') return false
        return  formatoNombre(nit,data.RESPONSE[0].NOMBRE)
   
}

function formatoNombre(nit,nombre){
    let cliente = nombre.split(',,')
    console.log(cliente)
   
    if(nombre.length>1){ //Validamos que nombre no venga vacio

        if(cliente.length>1){ //Validamos que cliente tenga mas de dos elementos en el arreglo que generó el split
            return cliente = cliente[1].replace(',',' ')+' '+cliente[0].replace(',',' ')
        }else if(cliente[0].length>1){ //Validamos que cliente no este vacio
            return nombre
        }

    }else{
        //return cliente =  nit==='CF'? 'CONSUMIDOR FINAL': false;
        if(nit!=='CF') throw new Error("No se encontró en Nit porfavor verificarlo");
        return 'CONSUMIDOR FINAL'
    }
    
}

export default findClienteSat;